"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcBadgeBehavior = void 0;
var bc_badge_constants_1 = require("./bc-badge-constants");
var bc_badge_constants_2 = require("./bc-badge-constants");
var bc_badge_constants_3 = require("./bc-badge-constants");
var bc_badge_constants_4 = require("./bc-badge-constants");
var bc_badge_constants_5 = require("./bc-badge-constants");
var bc_badge_constants_6 = require("./bc-badge-constants");
var bc_badge_constants_7 = require("./bc-badge-constants");
var bc_badge_constants_8 = require("./bc-badge-constants");
var bc_badge_constants_9 = require("./bc-badge-constants");
var bc_badge_constants_10 = require("./bc-badge-constants");
var bc_badge_constants_11 = require("./bc-badge-constants");
var bc_badge_constants_12 = require("./bc-badge-constants");
var bc_badge_constants_13 = require("./bc-badge-constants");
var bc_badge_constants_14 = require("./bc-badge-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var BcBadgeBehavior = (function (_super) {
    __extends(BcBadgeBehavior, _super);
    function BcBadgeBehavior() {
        return _super.call(this) || this;
    }
    BcBadgeBehavior.prototype.setPosition = function (position) {
        this.removePosition();
        if (position === 'button-left') {
            this.mySelf.classList.add(bc_badge_constants_12.BADGE_BUTTON_LEFT);
        }
        if (position === 'button-right') {
            this.mySelf.classList.add(bc_badge_constants_13.BADGE_BUTTON_RIGHT);
        }
        if (position === 'top-right') {
            this.mySelf.classList.add(bc_badge_constants_3.BADGE_TOP_RIGHT);
        }
        if (position === 'top-left') {
            this.mySelf.classList.add(bc_badge_constants_5.BADGE_TOP_LEFT);
        }
    };
    BcBadgeBehavior.prototype.removePosition = function () {
        if (this.mySelf.classList.contains(bc_badge_constants_12.BADGE_BUTTON_LEFT)) {
            this.mySelf.classList.remove(bc_badge_constants_12.BADGE_BUTTON_LEFT);
        }
        if (this.mySelf.classList.contains(bc_badge_constants_13.BADGE_BUTTON_RIGHT)) {
            this.mySelf.classList.remove(bc_badge_constants_13.BADGE_BUTTON_RIGHT);
        }
        if (this.mySelf.classList.contains(bc_badge_constants_3.BADGE_TOP_RIGHT)) {
            this.mySelf.classList.remove(bc_badge_constants_3.BADGE_TOP_RIGHT);
        }
        if (this.mySelf.classList.contains(bc_badge_constants_5.BADGE_TOP_LEFT)) {
            this.mySelf.classList.remove(bc_badge_constants_5.BADGE_TOP_LEFT);
        }
    };
    BcBadgeBehavior.prototype.setColor = function (color) {
        this.removeColor();
        if (color === 'red') {
            this.mySelf.classList.add(bc_badge_constants_4.BADGE_RED);
        }
        if (color === 'green') {
            this.mySelf.classList.add(bc_badge_constants_11.BADGE_GREEN);
        }
        if (color === 'yellow') {
            this.mySelf.classList.add(bc_badge_constants_6.BADGE_YELLOW);
        }
        if (color === 'pink') {
            this.mySelf.classList.add(bc_badge_constants_7.BADGE_PINK);
        }
        if (color === 'purple') {
            this.mySelf.classList.add(bc_badge_constants_8.BADGE_PURPLE);
        }
        if (color === 'blue') {
            this.mySelf.classList.add(bc_badge_constants_2.BADGE_BLUE);
        }
    };
    BcBadgeBehavior.prototype.removeColor = function () {
        if (this.mySelf.classList.contains(bc_badge_constants_4.BADGE_RED)) {
            this.mySelf.classList.remove(bc_badge_constants_4.BADGE_RED);
        }
        if (this.mySelf.classList.contains(bc_badge_constants_11.BADGE_GREEN)) {
            this.mySelf.classList.remove(bc_badge_constants_11.BADGE_GREEN);
        }
        if (this.mySelf.classList.contains(bc_badge_constants_6.BADGE_YELLOW)) {
            this.mySelf.classList.remove(bc_badge_constants_6.BADGE_YELLOW);
        }
        if (this.mySelf.classList.contains(bc_badge_constants_7.BADGE_PINK)) {
            this.mySelf.classList.remove(bc_badge_constants_7.BADGE_PINK);
        }
        if (this.mySelf.classList.contains(bc_badge_constants_8.BADGE_PURPLE)) {
            this.mySelf.classList.remove(bc_badge_constants_8.BADGE_PURPLE);
        }
        if (this.mySelf.classList.contains(bc_badge_constants_2.BADGE_BLUE)) {
            this.mySelf.classList.remove(bc_badge_constants_2.BADGE_BLUE);
        }
    };
    BcBadgeBehavior.prototype.setSize = function (size) {
        this.removeSize();
        if (size === 'small') {
            this.mySelf.classList.add(bc_badge_constants_9.BADGE_SMALL);
        }
        if (size === 'medium') {
            this.mySelf.classList.add(bc_badge_constants_10.BADGE_MEDIUM);
        }
    };
    BcBadgeBehavior.prototype.removeSize = function () {
        if (this.mySelf.classList.contains(bc_badge_constants_9.BADGE_SMALL)) {
            this.mySelf.classList.remove(bc_badge_constants_9.BADGE_SMALL);
        }
        if (this.mySelf.classList.contains(bc_badge_constants_10.BADGE_MEDIUM)) {
            this.mySelf.classList.remove(bc_badge_constants_10.BADGE_MEDIUM);
        }
    };
    BcBadgeBehavior.prototype.setBorder = function (border) {
        if (border) {
            this.mySelf.classList.add(bc_badge_constants_1.BADGE_BORDER);
        }
        else if (!border) {
            this.mySelf.classList.remove(bc_badge_constants_1.BADGE_BORDER);
        }
    };
    BcBadgeBehavior.prototype.setAnimation = function () {
        var _this = this;
        if (this.mySelf) {
            setTimeout(function () {
                _this.mySelf.classList.add(bc_badge_constants_14.BADGE_ANIMATION);
            });
            if (this.mySelf.classList.contains(bc_badge_constants_14.BADGE_ANIMATION)) {
                this.mySelf.classList.remove(bc_badge_constants_14.BADGE_ANIMATION);
            }
        }
    };
    BcBadgeBehavior.prototype.setNotification = function (sizeBadge, notification) {
        if (sizeBadge == 'medium' && Number.isInteger(notification)) {
            var number = 99;
            if (parseInt(notification) < number) {
                return notification;
            }
            else {
                return '99+';
            }
        }
        else {
            return '';
        }
    };
    return BcBadgeBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcBadgeBehavior = BcBadgeBehavior;
